<template>
    <section>
        <!--顶部查询条件-->
        <Form :model="tqtJournalism" inline>
            <FormItem>
                <Input v-model="tqtJournalism.title" placeholder="新闻标题" clearable></Input>
            </FormItem>
            <!--查询按钮-->
            <FormItem>
                <Button icon="ios-search" shape="circle" @click="search">查询</Button>
            </FormItem>

            <!--新建按钮-->
            <FormItem>
                <Button type="primary" icon="md-add" shape="circle" @click="create">新增</Button>
            </FormItem>

        </Form>
        <Table border :columns="columns" :data="tableData" :loading="loading"></Table>
        <div class="page-area">
            <Page :total="pageTotal" :current="pageOffset" :page-size="pageLength" @on-change="handlePageChange" show-total show-elevator/>
        </div>


    </section>
</template>
<script>
    import util from '@/libs/util.js'

    export default {
        name: 'tqtJournalismList',

        data () {
            return {
                loading:false,
                //分页参数
                pageLength: 10, // 每页条数
                pageTotal: 0,//总数
                pageOffset: 1, //页码
                //查询参数
                tqtJournalism: {
                    title: null,
                },
                columns: [
                    {
                        key: 'number',
                        title: '序号',
                        width: 70,
                        align: 'center',
                    },
                    {
                        key: 'title',
                        title: '标题',
                        align: 'center',
                    },

                    {
                        key: 'indexPic',
                        title: '首页图片',
                        align: 'center',
                        width: 180,
                        render: (h, params) => {
                            console.log(params.row, '111111111')
                            return h('div', [
                                h(
                                        'Img',
                                        {
                                            style:{'margin-top':'5px'},
                                            attrs: {
                                                src: params.row.imagePath.pic.url || '',
                                                width: '100%'
                                            },
                                        },
                                ),
                            ])
                        }
                    },
                    {
                        key: 'releaseTime',
                        title: '发布时间',
                        align: 'center',
                        width: 180,
                        render: (h, params) => {
                            return h('div', [
                                h(
                                        'span',
                                        {
                                            domProps: {
                                                innerHTML: this.formatTime(params.row.releaseTime)
                                                // innerHTML: this.formatTime('2021-04-14T12:50:48+08:00')
                                            },
                                        },
                                ),
                            ])
                        }
                    },
                    {
                        key: 'status',
                        title: '状态',
                        align: 'center',
                        width: 120,
                        render: (h, params) => {
                            return h('div', [
                                h(
                                        'span',
                                        {
                                            domProps: {
                                                innerHTML: params.row.status == '1' ? '已上架' : '已下架'
                                            },
                                        },
                                ),
                            ])
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        width: 220,
                        key: 'id',
                        render: (h, params) => {
                            if (params.row.status == 1) {
                                return h('div', [
                                    h(
                                            'Button',
                                            {
                                                props: {
                                                    type: 'warning',
                                                    size: 'small'
                                                },
                                                style: {
                                                    marginLeft: '5px'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.changeStatus(params.row.id, 0)
                                                    }
                                                }
                                            },
                                            '下架'
                                    ),
                                    h(
                                            'Button',
                                            {
                                                props: {
                                                    type: 'primary',
                                                    size: 'small'
                                                },
                                                style: {
                                                    marginLeft: '5px'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.edit(params.row.id)
                                                    }
                                                }
                                            },
                                            '编辑'
                                    ),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small'
                                        },
                                        style: {
                                            marginLeft: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.delete(params.row.id)
                                            }
                                        }
                                    }, '删除')
                                ])
                            } else {
                                return h('div', [
                                    h(
                                            'Button',
                                            {
                                                props: {
                                                    type: 'warning',
                                                    size: 'small'
                                                },
                                                style: {
                                                    marginLeft: '5px'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.changeStatus(params.row.id, 1)
                                                    }
                                                }
                                            },
                                            '上架'
                                    ),
                                    h(
                                            'Button',
                                            {
                                                props: {
                                                    type: 'primary',
                                                    size: 'small'
                                                },
                                                style: {
                                                    marginLeft: '5px'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.edit(params.row.id)
                                                    }
                                                }
                                            },
                                            '编辑'
                                    ),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small'
                                        },
                                        style: {
                                            marginLeft: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.delete(params.row.id)
                                            }
                                        }
                                    }, '删除')
                                ])

                            }

                        }
                    }
                ],
                tableData: []
            }
        },
        mounted () {
            this.listTable()
        },
        methods: {
            formatTime (UTCDateString) {
                if (!UTCDateString) {
                    return '-'
                }

                function formatFunc (str) {    //格式化显示
                    return str > 9 ? str : '0' + str
                }

                var date2 = new Date(UTCDateString)     //这步是关键
                var year = date2.getFullYear()
                var mon = formatFunc(date2.getMonth() + 1)
                var day = formatFunc(date2.getDate())
                var hour = date2.getHours()
                var min = formatFunc(date2.getMinutes())
                var second = date2.getSeconds()
                var dateStr = year + '-' + mon + '-' + day + ' ' + hour + ':' + min + ':' + second
                return dateStr
            },
            //渲染表格数据
            listTable () {
                let _this = this
                _this.loading = true
                util.http
                        .get('/api/tqtJournalismsByCriteria', {
                            params: {
                                page: _this.pageOffset,
                                size: _this.pageLength,
                                'title': _this.tqtJournalism.title,
                            }
                        })
                        .then(function (response) {
                            _this.tableData = []
                            let data = response.data
                            _this.pageTotal = data.recordsTotal
                            let list = data.data
                            _this.tableData = list.map((item, key) => {
                                item.number = key + 1
                                return item
                            })
                            _this.loading = false
                        })
                        .catch(function (error) {
                            console.log(error)
                            _this.loading = false
                        })
            },
            //新建
            create () {
                this.$router.push({
                    name: 'tqt_journalism_item',
                })
            },
            //编辑
            edit (id) {
                this.$router.push({
                    name: 'tqt_journalism_item',
                    query: {
                        id: id
                    }
                })
            },
            //删除
            delete (id) {
                let _this = this
                this.$Modal.confirm({
                    title: '确定删除？',
                    onOk () {
                        util.http.delete('/api/tqtJournalisms/' + id).then(response => {
                            if (response.status === 200) {
                                _this.$Notice.success({
                                    title: '删除成功'
                                })
                                _this.listTable()
                            } else {
                                _this.$Notice.error({
                                    title: '删除失败'
                                })
                            }
                        })
                    }
                })
            },
            //查询
            search () {
                this.pageOffset = 1
                this.listTable()
            },
            handlePageChange (current) {
                this.pageOffset = current
                this.listTable()
            },
            changeStatus (id, status) {
                let text
                if (status == 1) {
                    text = '上架'
                } else {
                    text = '下架'
                }
                this.$confirm(`即将${text}`, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: '确定',
                }).then(() => {
                    let _this = this
                    _this.saveLoading = true
                    util.http.post('/api/tqtUpdateJournalisms', {
                        id: id,
                        status: status
                    }, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }).then(function (response) {
                        _this.$Notice.success({
                            title: `${text}成功!`
                        })
                        _this.listTable()
                    }).catch(function (error) {
                        _this.$Notice.error({
                            title: `${text}失败!`
                        })
                        _this.saveLoading = false
                        console.log(error)
                    })
                })
            },
        }
    }
</script>
<style scoped>
    .query-model {
        width: 170px;
    }

    .page-area {
        display: flex;
        justify-content: flex-end;
        padding-top: 35px;
        padding-right: 50px;
    }
</style>
